import React from "react";
import { Box, Typography } from "@mui/material";
import { Transaction } from "../utils/types";
import { useMedia } from "../context/MediaContext";
type StatusType = Transaction["status"];

const statusConfig: Record<
  StatusType,
  { label: string; bg: string; color: string }
> = {
  dispute: { label: "Апеляция", bg: "#fdd83533", color: "#fdd835" },
  completed: { label: "Успех", bg: "#66bb6a33", color: "#66bb6a" },
  canceled: { label: "Ошибка", bg: "#ef535033", color: "#ef5350" },
  created: { label: "Создана", bg: "#ef535033", color: "#5e85f1ff" },
};

const ColorRadioButtons: React.FC<{
  selectedValue: StatusType;
  setSelectedValue: React.Dispatch<React.SetStateAction<Transaction | null>>;
}> = ({ selectedValue, setSelectedValue }) => {
  const handleClick = (value: StatusType) => {
    setSelectedValue((prev) => (prev ? { ...prev, status: value } : prev));
  };
  const { isMobile600 } = useMedia();
  return (
    <Box
      display="flex"
      justifyContent="center"
      gap={2}
      width="100%"
      height={isMobile600 ? "180px" : "110px"}
      alignItems={"center"}
      flexDirection={isMobile600 ? "column" : "row"}
    >
      {(["created", "completed", "canceled", "dispute"] as StatusType[]).map(
        (status) => {
          const selected = selectedValue === status;
          const config = statusConfig[status];
          return (
            <Box
              key={status}
              onClick={() => handleClick(status)}
              sx={{
                height: "35px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "15px 20px 10px 20px",
                width: isMobile600 ? "60%" : "20%",
                borderRadius: "20px",
                border: selected
                  ? `2px solid ${config.color}`
                  : "2px solid #ccc",
                background: selected
                  ? `linear-gradient(135deg, ${config.color}33, ${config.color}66)`
                  : "transparent",
                color: selected ? config.color : "#555",
                fontWeight: selected ? "bold" : "500",
                fontSize: "16px",
                transition: "all 0.3s ease",
                boxShadow: selected
                  ? `0 4px 12px ${config.color}55`
                  : "0 2px 5px #00000011",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: `0 6px 15px ${config.color}44`,
                },
              }}
            >
              <Typography textAlign="center">{config.label}</Typography>
            </Box>
          );
        }
      )}
    </Box>
  );
};

export default ColorRadioButtons;
